<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export PO</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/po">
					Back to Purchase Order List
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>
			<div>
				<b-datepicker :date-formatter="dateFormatter" placeholder="Starting Date" v-model="startingDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</div>

			<div>
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Ending Date"
					v-model="endingDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-button type="is-info" @click="exportPO()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
		<br /><br />

		<div class="button-container export-pdf-button" v-if="exportPo.length > 0">
			<div class="big-button" @click="print()">
				SAVE PDF FILE
			</div>
		</div>

		<div id="printing" v-if="exportPo.length > 0">
			<div v-for="(poDetail, index) of exportPo" v-bind:key="index">
				<div v-if="poDetail.purchase_order.status == true && poDetail.purchase_order.disable == false">
					<div class="logo">
						<img class="logo" src="../assets/bdlogo.png" />
					</div>

					<div class="order-details-wrapper">
						<div class="order-details">
							<h1>ORDER</h1>
							<span>ORDER ID: {{ poDetail.purchase_order.code }}</span>
							<br />
							<span>ORDER DATE: {{ convertTime(poDetail.purchase_order_items[0].order_date) }}</span>
							<br />
							<span>EXPECTED DATE: {{ convertTime(poDetail.purchase_order_items[0].expected_date) }}</span>
							<br />
							<span>BRAND: {{ poDetail.purchase_order.brand.name }}</span>
							<br />
							<span>{{ getLocationLabel(poDetail.purchase_order) }}: {{ getLocationName(poDetail.purchase_order) }}</span>
						</div>
						<div class="order-details">
							<br /><br />
							<span>MAIN OFFICE ADDRESS:</span>
							<br />
							<span>No. 92(A) , U Aung Kain Street, <br />Than Lwin Road, Golden Valley 1</span>
						</div>
					</div>

					<div class="order-items-wrapper">
						<div class="order-items header">
							<span>
								No.
							</span>
							<span>
								DESCRIPTION
							</span>
							<span>
								BD CODE
							</span>
							<span>
								BARCODE
							</span>
							<span>
								PRICE
							</span>
							<span>
								QUANTITY
							</span>
							<span class="amount">
								AMOUNT
							</span>
						</div>

						<div class="order-items" v-for="(item, index) of poDetail.purchase_order_items" v-bind:key="index">
							<!-- <div v-if="Number.isInteger(index / 10)">
								<div class="page-break"></div>
							</div> -->
							<span>
								{{ index + 1 }}
							</span>
							<span>
								{{ item.product.name }}
								<br />
								<span class="export-order-id">{{ getLocationName(poDetail.purchase_order) }}</span>
							</span>
							<span>
								{{ item.product.bd_code }}
							</span>
							<span>
								{{ item.product.barcode }}
							</span>
							<span>
								{{ getItemAmount(item) }}
							</span>
							<span>
								{{ item.qty }}
								<br />
								<!-- Display packaging selection below quantity with lighter font -->
								<span class="packaging-text">{{ getPackagingSelection(item) }}</span>
							</span>
							<span class="amount">
								{{ getTotalAmount(item) }}
							</span>
						</div>
					</div>

					<div class="order-items">
						<span> </span>
						<span> </span>
						<span> </span>
						<span> </span>

						<span class="total">
							TOTAL
						</span>
						<span class="total">
							{{ poDetail.totalQuantity }}
						</span>
						<span class="amount total">
							{{ poDetail.orderTotal.toLocaleString('en-GB') }}
						</span>
					</div>
					<div class="page-break"></div>
				</div>
				<!-- end of v-if -->
			</div>
		</div>
	</div>
</template>

<script>
import { Printd } from 'printd'

export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			po: [],
			exportPo: [],
			totalLoop: 0,
			progress: 0,
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null,
			cssText: `#printing {
	font-family: "Segoe UI", "Calibri", "Arial";
  width: 1000px;
  margin: auto;
  padding: 20px;
}

#printing .logo {
  width: 300px;
  text-align: left;
}

#printing .order-details-wrapper {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-gap: 10px;
}

#printing .order-details {
  padding: 10px;
  text-align: left;
}

#printing .export-order-id {
	font-weight: bold;
	font-size: 12px;
	color: #999;
	text-align: left;
	border-top: none;
}

#printing .order-details h1 {
  font-weight: bold;
  font-size: 30px;
}

#printing .order-items {
  display: grid;
  grid-template-columns: 50px 1fr 100px 150px 100px 70px 100px;
  grid-gap: 10px;
  padding: 15px 5px;
  font-size: 16px;
  border-top: 1px solid #ccc;
}

#printing .order-items-wrapper {
  text-align: left;
  margin-top: 20px;
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  padding: 10px 0;
}

#printing .order-details span {
  font-weight: bold;
  font-size: 15px;
  color: #999;
  text-align: center;
  line-height: 26px;
}


#printing .order-items-wrapper .header {
  font-weight: bold;
  font-size: 12px;
  color: #999;
  text-align: left;
  border-top: none;
}

#printing .packaging-text {
  font-size: 11px;
  color: #666;
  font-weight: normal;
  font-style: italic;
}

#printing .amount {
  text-align: right;
  font-weight: bold;
  color: #000;
}

#printing .total {
  font-weight: bold;
  padding-top: 20px;
  height: 50px;
}

#printing .page-break {
  page-break-after: always;
}
`
		}
	},

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		this.d = new Printd()

		const { contentWindow } = this.d.getIFrame()

		contentWindow.addEventListener('beforeprint', () => 'before print event!')

		contentWindow.addEventListener('afterprint', () => 'after print event!')

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		print: function() {
			this.d.print(document.getElementById('printing'), [this.cssText])
		},

		exportPO: async function() {
			// Set default data
			this.po = []
			this.exportPo = []

			this.totalLoop = 0
			this.progress = 0

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			// To filter with start and end date
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: 1,
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getPO({ data })

			// Loop to get all data
			if (apiGetPO) {
				const total = apiGetPO.data.total
				const totalLoop = Math.ceil(apiGetPO.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					const result = await this.getPO(skip)

					result.map(item => {
						this.po.push(item)
					})
				}

				this.progress = 100
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false

				return
			}

			// Get po details with products
			if (this.po.length > 0) {
				let count = 0
				// this.po.map(async po => {
				for (const po of this.po) {
					count++
					const brand = po.brand
					const shop = po.shop

					this.progress = (count / this.po.length) * 100

					var data = {
						id: po._id,
						populate_purchase_order: ['author', 'supplier', 'shop', 'brand'],
						populate_purchase_order_item: ['product']
					}

					const apiGetPO = await this.$api.getPODetail({ data })

					// Calculate totals for the PO
					apiGetPO.data.orderTotal = 0
					apiGetPO.data.totalQuantity = 0

					apiGetPO.data.purchase_order_items.map(item => {
						const price = item.product.original_price || item.product.price || 0
						const amount = price * (item.qty || 0)
						apiGetPO.data.orderTotal += amount
						apiGetPO.data.totalQuantity += item.qty || 0
					})

					// Store as array element instead of object key
					this.exportPo.push(apiGetPO.data)
				}
			}

			let finalData = ''

			// Header
			finalData += 'PO CODE,DATE,TIME,USER,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,QUANTITY,PRICE,NET AMOUNT\r\n'

			// Loop through exportPo array instead of object
			this.exportPo.forEach(poData => {
				const purchase_order = poData.purchase_order
				const purchase_order_items = poData.purchase_order_items

				let total_request = 0
				let total_amount = 0

				purchase_order_items.map(po_items => {
					const product = po_items.product

					const product_price = product.commission > 0 || product.original_price < 2 ? product.price : product.original_price

					const toAdd = [
						purchase_order.code,
						this.$moment(purchase_order.createdAt).format('DD/MM/YY'),
						this.$moment(purchase_order.createdAt).format('hh:mm a'),
						purchase_order.author.name,
						product.bd_code,
						product.barcode,
						'"' + product.name + '"',
						purchase_order.brand.name,
						purchase_order.brand.code,
						po_items.qty,
						product_price,
						product_price * po_items.qty
					]

					total_request += po_items.qty
					total_amount += product_price * po_items.qty

					let row = toAdd.join(',')

					finalData += row + '\r\n'
				})

				finalData += ',,,,,,,,Total,' + total_request + ',,' + total_amount + '\r\n\r\n'
			})

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Warehouse_PO_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false

			this.isLoading = false
		},

		getPO: async function(skip = 0) {
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: this.limit,
				populate: ['author', 'supplier', 'shop', 'brand'],
				time: {
					createdAt
				}
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.brand = this.selectedBrand._id
			}

			const apiGetPO = await this.$api.getPO({ data })

			return apiGetPO.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		// Helper methods for template
		getItemAmount: function(item) {
			const price = item.product.original_price || item.product.price || 0
			return price.toLocaleString('en-GB')
		},

		getTotalAmount: function(item) {
			const price = item.product.original_price || item.product.price || 0
			const amount = price * (item.qty || 0)
			return amount.toLocaleString('en-GB')
		},

		getPackagingSelection: function(item) {
			// Check if packaging_selection exists and has value, otherwise return 'single_item'
			if (item && item.packaging_selection && item.packaging_selection.trim() !== '') {
				return item.packaging_selection
			}
			return 'single_item'
		},

		getLocationLabel: function(purchaseOrder) {
			// Return appropriate label based on PO type
			if (purchaseOrder && purchaseOrder.shop) {
				return 'SHOP'
			} else if (purchaseOrder && purchaseOrder.warehouse) {
				return 'WAREHOUSE'
			}
			return 'LOCATION'
		},

		getLocationName: function(purchaseOrder) {
			// Return location name based on what's available
			if (purchaseOrder && purchaseOrder.shop && purchaseOrder.shop.name) {
				return purchaseOrder.shop.name
			} else if (purchaseOrder && purchaseOrder.warehouse && purchaseOrder.warehouse.name) {
				return purchaseOrder.warehouse.name
			} else if (purchaseOrder && purchaseOrder.supplier && purchaseOrder.supplier.name) {
				return purchaseOrder.supplier.name
			}
			return 'N/A'
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';

.button-container {
	width: 200px;
	margin: auto;
	padding: auto;
}

/* For Printing ONLY! */
#printing {
	font-family: 'Segoe UI', 'Calibri', 'Arial';
	width: 1000px;
	margin: auto;
	padding: 20px;
}

#printing .logo {
	width: 300px;
	text-align: left;
}

#printing .order-details-wrapper {
	margin-top: 20px;
	display: grid;
	grid-template-columns: 1fr 300px;
	grid-gap: 10px;
}

#printing .order-details {
	padding: 10px;
	text-align: left;
}

#printing .order-details h1 {
	font-weight: bold;
	font-size: 30px;
}

#printing .order-items {
	display: grid;
	grid-template-columns: 50px 1fr 100px 150px 100px 70px 100px;
	grid-gap: 10px;
	padding: 15px 5px;
	font-size: 16px;
	border-top: 1px solid #ccc;
}

#printing .order-items-wrapper {
	text-align: left;
	margin-top: 20px;
	border-top: 2px solid #333;
	border-bottom: 2px solid #333;
	padding: 10px 0;
}

#printing .order-details span {
	font-weight: bold;
	font-size: 15px;
	color: #999;
	text-align: center;
	line-height: 26px;
}

#printing .order-items-wrapper .header {
	font-weight: bold;
	font-size: 12px;
	color: #999;
	text-align: left;
	border-top: none;
}

#printing .export-order-id {
	font-weight: bold;
	font-size: 12px;
	color: #999;
	text-align: left;
	border-top: none;
}

#printing .amount {
	text-align: right;
	font-weight: bold;
	color: #000;
}

#printing .total {
	font-weight: bold;
	padding-top: 20px;
	height: 50px;
}

#printing .page-break {
	page-break-after: always;
}
</style>
